// noinspection JSUnresolvedReference

import Modal from "react-modal";
import {customAdaptativeModal, viewItemProduct, viewLogOperation} from "../../../../classes/functions";

export default function ModalViewLog({modalViewLog, closeModal, view, view_log, listProducts, viewLogFeatures}) {
    return (
        <Modal
            isOpen={modalViewLog}
            onRequestClose={closeModal}
            style={customAdaptativeModal}
            contentLabel="Origem"
            ariaHideApp={false}
            keepMounted
        >
            <div className="body-modal">
                <div className="divGroup">
                    <h2>Histórico em {view_log.data} - {view_log.hora} - {viewLogOperation(view_log.operacao)}</h2>
                </div>
                <div className="divGroup">
                    <h3>Usuário {view_log.user}</h3>
                </div>
                <div className="divGroup">
                    <div className="formDiv">
                        <table>
                            <thead>
                            <tr>
                                <th>Campo</th>
                                <th>Valor</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Documento</td>
                                <td>{view_log.dados?.row?.numero_documento}</td>
                            </tr>
                            <tr>
                                <td>Observação</td>
                                <td>{view_log.dados?.row?.observacao}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>{view_log.status}</td>
                            </tr>
                            <tr>
                                <td>Data</td>
                                <td>{view_log?.data}</td>
                            </tr>
                            <tr>
                                <td>Hora</td>
                                <td>{view_log?.hora}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {view_log?.dados?.rows?.length > 0 && <h3>Itens</h3>}
                {view_log?.dados?.rows?.length > 0 && <div className="divGroup">
                    <div className="formDiv">
                        <table>
                            <thead>
                            <tr>
                                <th scope="col">Produto</th>
                                {view_log?.dados?.rows[0]?.id_caracteristica_produto?.length > 0 &&
                                    <th scope="col">Caracteristicas</th>}
                                <th scope="col">Quantidade Solicitada</th>
                                <th scope="col">Quantidade Separada</th>
                                <th scope="col">Quantidade Conferida</th>
                                <th scope="col">Quantidade Solicitada Devolução</th>
                                <th scope="col">Quantidade Devolvida</th>
                                <th scope="col">Quantidade Eliminada</th>
                            </tr>
                            </thead>
                            <tbody>
                            {view_log?.dados?.rows.map((item, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{viewItemProduct(listProducts, item.id_produto)}</td>
                                        {item.id_caracteristica_produto?.length > 0 && <td>
                                            <button type="button" className="buttonTable"
                                                    onClick={() => viewLogFeatures(item)}>
                                                Ver características
                                            </button>
                                        </td>}
                                        <td>{item.quantidade ? item.quantidade : 0}</td>
                                        <td>{item.qtde_separada ? item.qtde_separada : 0}</td>
                                        <td>{item.qtde_devolvida ? item.qtde_devolvida : 0}</td>
                                        <td>{item.qtde_pendente_devolucao ? item.qtde_pendente_devolucao : 0}</td>
                                        <td>{item.qtde_eliminada ? item.qtde_eliminada : 0}</td>
                                        <td>{item.qtde_conferida ? item.qtde_conferida : 0}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>}
                <div className="formDiv">
                    <button type="button" className="buttonCancel" onClick={closeModal}>Fechar
                    </button>
                </div>
            </div>
        </Modal>
    )
}